import {
  LightDomStyles,
  OutlineElement,
  SlotsController,
} from '@phase2/outline-core';
import { html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import componentStyles from './outline-anchor-block.css.lit';

/**
 * The Anchor Blockcomponent.
 * @element outline-anchor-block
 * @slot defaultSlot
 */
@customElement('outline-anchor-block')
export class OutlineAnchorBlock extends OutlineElement {
  static styles = [componentStyles];

  slots = new SlotsController(this);

  lightDomStyles = new LightDomStyles(
    this,
    [componentStyles],
    this.tagName.toLowerCase()
  );

  @property({ type: String, reflect: true, attribute: 'variant' })
  variant: 'inline' | 'stacked';

  render(): TemplateResult {
    return html`
      <div class="anchor-block ${this.variant}">
        <div class="inner">
          <div class="left-col">
            ${this.slots.conditionalSlot('heading', false)}
          </div>
          <div class="right-col">
            ${this.slots.conditionalSlot('anchor-link', false)}
          </div>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'outline-anchor-block': OutlineAnchorBlock;
  }
}
